<template>
    <div>
        <vx-tooltip id="printSelectedShippingLabels" class="vs-con-loading__container" :text="getToolTipText()">
            <vs-button color="primary" @click.native="selectedPrintShippingLabels()" :disabled="isButtonDisabled()">
                <font-awesome-icon :icon="['fas', 'print']" class="fa-icon" />
            </vs-button>
        </vx-tooltip>
    </div>
</template>

<script>
import dymoLabels from '../../services/dymo/dymoLabels';
import dymoPrinter from '../../services/dymo/dymoPrinter';

export default {
	props: {
		dymoPrinter: {
			type: dymoPrinter,
			required: true,
		}
	},
	methods: {
		getToolTipText() {
			if (this.$parent.getSelectedOrdersCount() === 0) {
				return 'Er is geen bestelling geselecteerd'
			}

			if (!this.dymoPrinter.shippingPrinterReady()) {
				return 'Er is geen verbinding met de adres label printer';
			}

			if (this.$parent.getSelectedOrdersCount() === 1) {
				return 'Print adres label';
			}

			return 'Print adres labels';
		},
		isButtonDisabled() {
			if (!this.dymoPrinter.shippingPrinterReady()) {
				return true;
			}

			return this.$parent.getSelectedOrdersCount() === 0;
		},
		selectedPrintShippingLabels() {
			this.startLoading();

			const selectedOrders = this.$parent.getSelectedOrders();

			this.dymoPrinter.printShippingLabels(selectedOrders).then(response => {
				this.stopLoading();
			}).catch(error => {
				this.stopLoading();
			});
		},
		startLoading() {
			this.$vs.loading({
				container: '#printSelectedShippingLabels',
				scale: 0.45
			})
		},
		stopLoading() {
			this.$vs.loading.close('#printSelectedShippingLabels > .con-vs-loading')
		}
	}
}
</script>
